import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaNumericTextImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.NUMERIC_TEXT;
    }
}
